import apiClient from '@/clients/apiClient';

export default {
  getPendingChecks(params) {
    return apiClient.get('/maker-checkers/pending', { params });
  },

  getCheckDetails(id) {
    return apiClient.get(`/maker-checkers/${id}`);
  },

  getCheckItemDetails({ itemType, itemId }) {
    return apiClient.get(`/maker-checkers/${itemType}/${itemId}`);
  },

  updateCheckStatus(id, status, comments = '') {
    return apiClient.post(`/maker-checkers/${id}/status`, {
      status,
      ...(comments ? { comments } : {})
    });
  },

  getRequestedChecks(params) {
    return apiClient.get('/maker-checkers/requested', { params });
  }
}; 